import { Component } from 'react';
import { Flow } from 'flow-react';
import { observer } from "mobx-react"
import { Container, Row, Col} from 'react-bootstrap';
import './Channelsmenu.css';


const Channelsmenu = observer(
  class Channelsmenu extends Component {
	
		//mapping der Chains auf classnames, das wird in der reihenfolge durchgegangen 
		//"France 3 Régions","france_3_regions" ist nicht ddrin weil es keinen eigenen menuepunkt hat
		chains = ["Réseau la 1ère","France 2","France 3","France 4","France 5","Outre-Mer la 1ère","francetv-la plateforme","france.tv distribution"];
		chacls = ["reseau_la_1ere","france_2","france_3","france_4","france_5","outre_mer_la_1ere","france_tv_platform","france_tv_distribution"];
		//genres sind nur dazu da: wenn man ein genre in seinen stations hat, bekommt man immer alle chains
		genres = ["Sport","Jeunesse","Information"];


		stats = ["Guadeloupe","Guyane","La Réunion","Martinique","Mayotte","Nouvelle Calédonie","Polynésie","Saint-Pierre et Miquelon","Wallis et Futuna"]
		stcls = ["guadeloupe","guyane","la_reunion","martinique","mayotte","nouvelle_caledonie","polynesie","saint_pierre_et_miquelon","wallis_et_futuna"]


		
		//Klassennamen zu Meta
		cTom = (c) => {
			return this.chains[this.chacls.indexOf(c)];
		}
		//Meta zu Klassennamen
		mToc = (c) => {
			return this.chacls[this.chains.indexOf(c)];
		}
		
		//wenn man auf ein chain klick, wird es an- oder abgewaehlt und die suche angestossen
		toggleChain(c) {
			if(c == 'france_3') //wenn man auf das f3-logo klickt soll (hier) nichts passieren, sondern das dropdown kommt
				return false;
			if(c == 'reseau_la_1ere') //wie bei f3: da kommt ein dropdown
				return false;
			if(c == 'france_3_n') //das ist dann ein unterpunkt von f3 (national)
				c = 'france_3';
			let cm = this.cTom(c);
			if(c == 'france_3_r') 
				cm = 'France 3 Régions';
			if(typeof(cm) != 'string')
				return false;//das sollte bei statis gar nicht aufgerufen werden, wird es aber, dann ist cm undefined
			let currchains = this.props.skchains;
			if(currchains.indexOf(cm) > -1)  
				currchains.splice(currchains.indexOf(cm),1)
			else
				currchains.push(cm);
			this.props.setcritcb({chains:currchains});
		}
		
		toggleStat(s) {
			let ms = this.stats[this.stcls.indexOf(s)];
			let currstatis = this.props.skstatis;
			if(currstatis.indexOf(ms) > -1)  
				currstatis.splice(currstatis.indexOf(ms),1)
			else
				currstatis.push(ms);
			this.props.setcritcb({statis:currstatis});
			
		}
		
		
		//das macht ein array mit klassennamen von chains, die man angezeigt bekommt
		getStations = () => {
			let us = this.props.user.stations;
			let erg = [];
			for(var g of this.genres)
				if(us.indexOf(g) > -1)
					return this.chacls;//wenn es ein genre gibt, zeige alle chains an
			for(var c of this.chains) {
				if(us.indexOf(c) > -1)
					erg.push(this.mToc(c));
			}
			return erg;
		}
		
		mkAddDrop = (chain) => {
			if(chain == 'france_3') 
				return (<ul className="f3rdropdown">
								<li className={'chainli chb_france_3_n' + this.mkAddClass('france_3_n')} onClick={()=>{ this.toggleChain('france_3_n') }}>National</li>
								<li className={'chainli chb_france_3_r' + this.mkAddClass('france_3_r')} onClick={()=>{ this.toggleChain('france_3_r') }}>Régions</li>
							 </ul>)
			if(chain == 'reseau_la_1ere') 
				return (<ul className="f3rdropdown">
									{this.stats.map(s => {
										let sc = this.stcls[this.stats.indexOf(s)];
										return <li key={sc} className={'chainli chb_' + sc + this.mkAddStatiClass(sc)} onClick={()=>{ this.toggleStat(sc) }}>{s}</li>
									})}
							 </ul>)
			return null;
		}
		
		mkAddStatiClass = (s) => {
			if(this.props.skstatis.indexOf(this.stats[this.stcls.indexOf(s)]) > -1) 
				return ' selected';
			return '';
		}
		
		mkAddClass = (cl) => {
			if(cl == 'reseau_la_1ere') {
				if(this.props.skstatis.filter(value => this.stats.includes(value)).length > 0)
					return ' selected';
			}
				
			//array1.filter(value => array2.includes(value));
			if((cl == 'france_3_r' || cl == 'france_3') && this.props.skchains.indexOf('France 3 Régions') > -1)
				return ' selected';
			if(cl == 'france_3_n' && this.props.skchains.indexOf('France 3') > -1)
				return ' selected';
			if(this.props.skchains.indexOf(this.cTom(cl)) > -1) 
				return ' selected';
			return '';
		}
		
		resetFilter = (ev) => {
			document.getElementById('mainsearchinput').value = '';
			this.props.setcritcb({offset:0,weeks:[],chains:[],statis:[],genres:[],fulltext:''});
		}
		
    render() {
			return  (
				<Row className="chnrow">
						<Col 
							md={1} sm={4}
							key={'mlogo'} 
							onClick={()=>{ this.resetFilter() }}
							className={'chainbig chb_tvlogo'}>
						</Col>
				{this.getStations().map(c => {
					return (
						<Col 
							md={1} sm={4}
							key={c} 
							onClick={()=>{ this.toggleChain(c) }}
							className={'chainbig chb_' + c + this.mkAddClass(c)}>
								{this.mkAddDrop(c)}
						</Col>)
				})
				}
				</Row>
			)
    }
		
  }
)


export default Flow.injectFlow(Channelsmenu);